import React, { useEffect, useState } from "react";
import "./JobStatus.css";
import OnVacation from "../images/onVacation.png";
import wfh from "../images/wfh.png";
import sickLeave from "../images/sickLeave.png";
import dayOff from "../images/dayOff.png";
import tripB from "../images/tripB.png";
import DOF from "../images/DOF.png";
import WFH from "../images/WFH2.png";
import TopCardPopUp from "./TopCardPopUp";
import { format } from "date-fns";
import { base_url as base_url_from_axios_config } from "../../utils/AxiosConfig";
import axios from "axios";
import { Player } from "@lottiefiles/react-lottie-player";
import expiryAnimation from "../images/insurExp2.png";
import passport_card_image from "../../images/passport_card.svg";
import visa_card_image from "../../images/visa_card_image.svg";
import national_id_image from "../../images/visa_card_image.svg";
import insurance_image from "../../images/insurance_card.svg";
import document_card from "../../images/document_card.svg";
import driving_license from "../../images/driving_license.svg";
import TopCardPopUpExpiryList from "./TopCardPopUpExpiryLsit";
import { FaPassport, FaIdCard, FaRegCreditCard, FaUser } from "react-icons/fa";
import { MdShield, MdDirectionsCar , MdAssignmentInd } from "react-icons/md";
import { HiOutlineDocument, HiIdentification } from "react-icons/hi";
import { useNavigate } from "react-router-dom";

// ── Item config ──────────────────────────────────────────────────────────────
// Centralised so adding/removing a card is a one-line change.
const EXPIRY_ITEMS = [
  {
    key: "passport",
    label: "Passport",
    popUpId: "Passport Expiry",
    listName: "PASSPORTEXPLIST",
    Icon: FaPassport,
    iconBg: "bg-blue-500",
    ringColor: "focus:ring-blue-400",
    countKey: "passport",
  },
  {
    key: "drivingLic",
    label: "License",
    popUpId: "Driving License Expiry",
    listName: "DRIVINGLICEXPLIST",
    Icon: FaIdCard,
    iconBg: "bg-amber-500",
    ringColor: "focus:ring-amber-400",
    countKey: "drivingLic",
  },
  {
    key: "visa",
    label: "Visa",
    popUpId: "Visa Expiry",
    listName: "VISAEXPLIST",
    Icon: FaRegCreditCard,
    iconBg: "bg-emerald-500",
    ringColor: "focus:ring-emerald-400",
    countKey: "visa",
  },
  {
    key: "insurance",
    label: "Insurance",
    popUpId: "Insurance Expiry",
    listName: "INSURANCEEXPLIST",
    Icon: MdShield,
    iconBg: "bg-red-500",
    ringColor: "focus:ring-red-400",
    countKey: "insurance",
  },
  {
    key: "nationalId",
    // label: "National ID",
    label: "Emirates ID",
    popUpId: "National ID Expiry",
    listName: "NATIONALIDEXPLIST",
    Icon: HiIdentification,
    iconBg: "bg-pink-500",
    ringColor: "focus:ring-pink-400",
    countKey: "nationalId",
  },
  {
    key: "companyDocs",
    listName: "COMPANYDOCSEXPLIST",
    label: "Documents",
    popUpId: "Company Documents Expiry",
    listName: "COMPANYDOCSEXPLIST",
    Icon: HiOutlineDocument,
    iconBg: "bg-purple-500",
    ringColor: "focus:ring-purple-400",
    countKey: "companyDocs",
  },
  {
    // Labor card expiry 
    key: "personId",
    label: "Labor Card Expiry",
    popUpId: "Person ID",
    listName: "PERSONIDEXPLIST",
    Icon: FaUser,
    iconBg: "bg-indigo-500",
    ringColor: "focus:ring-indigo-400",
    countKey: "personId",
  },
    {
    key: "partTimeLabor",
    label: "Part Time Labor Expiry",
    popUpId: "Part Time Labor Card Expiry",
    listName: "PARTTIMELIST",
    Icon: MdAssignmentInd,
    iconBg: "bg-orange-500",
    ringColor: "focus:ring-orange-400",
    countKey: "partTimeLabor",
  },
  {
    key: "fleet",
    label: "Fleet Expiry",
    popUpId: "Fleet Expiry",
    listName: "FLEETLIST",
    Icon: MdDirectionsCar,
    iconBg: "bg-teal-500",
    ringColor: "focus:ring-teal-400",
    countKey: "fleet",
  },
  {
    key: "fleetInsur",
    label: "Fleet Insurance Expiry",
    popUpId: "Fleet Insurance Expiry",
    // listName: "FLEETINSURLIST",
    listName: "FLEETINSURANCE",
    Icon: MdDirectionsCar,
    iconBg: "bg-teal-500",
    ringColor: "focus:ring-teal-400",
    countKey: "fleetInsur",
  },


];

const ExpiryCount = () => {
  const [dataFromParent, setDataFromParent] = useState(null);
  const [list_name, setListName] = useState("");

  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  let companyCode = null;
  if (storedUserDataArray) {
    companyCode = storedUserDataArray[0].cmpcode;
  }

  // ── All original state preserved ────────────────────────────────────────
  const [passPortCount, setPassPortCount] = useState(null);
  const [fleetExpiryCount, setFleetExpiryCount] = useState(null);
  const [fleetInsurExpiryCount, setFleetInsurExpiryCount] = useState(null);
  const [partTimeExpiryCount, setPartTimeExpiryCount] = useState(null);
  const [visaCount, setVisaCount] = useState(null);
  const [nationalIdCount, setNationalIdCount] = useState(null);
  const [personalIdCount, setPersonalIdCount] = useState(null);
  const [insuranceCount, setInsuranceCount] = useState(null);
  const [companyDocsCount, setCompanyDocsCount] = useState(null);
  const [drivingLicenceCount, setDrivingLicenceCount] = useState(null);
  const [birthdayCount, setBirthdayCount] = useState(null);
  const [showJobCardPopUp, setShowJobCardPopUp] = useState(false);
  const [popUpId, setPopUpId] = useState("");
  const [leaveCount, setLeaveCount] = useState(null);
  const [loading, setLoading] = useState(true);

  const [base_url, setBaseUrl] = useState(`${base_url_from_axios_config}/`);

  const openJobCardModal = (id) => {
    setShowJobCardPopUp(true);
    setPopUpId(id);
  };

  const closeJobCardModal = () => setShowJobCardPopUp(false);

  // ── Leave-derived counts ─────────────────────────────────────────────────
  const sickLeaveCount =
    leaveCount?.find((l) => l.leave_key === "Sick Leave")?.count || 0;
  const vacationCount =
    leaveCount?.find((l) => l.leave_key === "On Vacation")?.count || 0;
  const wfhCount =
    leaveCount?.find((l) => l.leave_key === "Work From Home")?.count || 0;
  const dayOffCount =
    leaveCount?.find((l) => l.leave_key === "Person ID")?.count || 0;
  const businessTripCount =
    leaveCount?.find((l) => l.leave_key === "Business Trip")?.count || 0;

  // ── API calls (all original logic untouched) ─────────────────────────────
  useEffect(() => {
    const today = format(new Date(), "dd-MMM-yyyy").toLowerCase();
    const apiUrl = `${base_url}api/HRDashboard/${companyCode}/-/LEAVECOUNT/${today}/${today}/-/-/-/-/-`;
    const fetchLeaveCount = async () => {
      try {
        const response = await axios.get(apiUrl);
        setLeaveCount(response.data);
      } catch (error) {
        console.error("Error fetching leave count:", error);
      }
    };
    if (base_url) fetchLeaveCount();
  }, []);

  useEffect(() => {
    if (!base_url) return;

    const calls = [
      {
        url: `${base_url}api/cpayscount/${companyCode}/passport/-/-`,
        setter: setPassPortCount,
      },
      {
        url: `${base_url}api/cpayscount/${companyCode}/fleet/-/-`,
        setter: setFleetExpiryCount,
      },
      // {
      //   url: `${base_url}api/cpayscount/${companyCode}/FLEETREGISTRATIONCNT/-/-`,
      //   setter: setFleetExpiryCount,
      // },
      {
        url: `${base_url}api/cpayscount/${companyCode}/FLEETINSURANCECNT/-/-`,
        setter: setFleetInsurExpiryCount,
      },
      {
        url: `${base_url}api/cpayscount/${companyCode}/PARTTIMECNT/-/-`,
        setter: setPartTimeExpiryCount,
      },
      {
        url: `${base_url}api/cpayscount/${companyCode}/visa/-/-`,
        setter: setVisaCount,
      },
      {
        url: `${base_url}api/cpayscount/${companyCode}/nationalid/-/-`,
        setter: setNationalIdCount,
      },
      {
        url: `${base_url}api/cpayscount/${companyCode}/personid/-/-`,
        setter: setPersonalIdCount,
      },
      {
        url: `${base_url}api/cpayscount/${companyCode}/insurance/-/-`,
        setter: setInsuranceCount,
      },
      {
        // url: `${base_url}api/cpayscount/${companyCode}/companydocs/-/-`,
        url: `${base_url}api/cpayscount/${companyCode}/COMPANYDOCSEXPLISTCNT/-/-`,
        setter: setCompanyDocsCount,
      },
      {
        url: `${base_url}api/cpayscount/${companyCode}/drivinglic/-/-`,
        setter: setDrivingLicenceCount,
      },
      {
        url: `${base_url}api/cpayscount/${companyCode}/birthday/-/-`,
        setter: setBirthdayCount,
      },
    ];

    const fetchAll = async () => {
      setLoading(true);
      await Promise.all(
        calls.map(async ({ url, setter }) => {
          try {
            const res = await axios.get(url);
            const count = res.data[0]?.Cnt ?? res.data[0]?.Column1 ?? 0;
            setter(count);
          } catch (err) {
            console.error("Error fetching expiry count:", err);
          }
        }),
      );
      setLoading(false);
    };

    fetchAll();
  }, []);

  const getList = () => {
    const apiUrl = `${base_url}api/CpaysCount/${companyCode}/${list_name}/-/-`;
    console.log("apiUrl explsit - > ", apiUrl);
    axios
      .get(apiUrl)
      .then((res) => setDataFromParent(res.data))
      .catch(() => {});
  };

  useEffect(() => {
    getList();
  }, [list_name]);

  // ── Map count keys → actual state values ─────────────────────────────────
  const countMap = {
    passport: passPortCount,
    fleet: fleetExpiryCount,
    fleetInsur: fleetInsurExpiryCount,
    partTimeLabor: partTimeExpiryCount,
    drivingLic: drivingLicenceCount,
    visa: visaCount,
    insurance: insuranceCount,
    nationalId: nationalIdCount,
    companyDocs: companyDocsCount,
    personId: personalIdCount,
  };

  const totalExpiring = Object.values(countMap).reduce(
    (sum, v) => sum + (v || 0),
    0,
  );

  const navigate = useNavigate();

  const navigateToEdit = (empId, listName) => {
    if (listName === "COMPANYDOCSEXPLIST") {
      navigate(`/admin/documentExpiry`);
    } else if (listName === "FLEETLIST") {
      navigate(`/admin/fleetRegistrationExpiry`);
    } else if (listName === "FLEETINSURANCE") {
      navigate(`/admin/fleetInsuranceExpiry`);
    } else {
      navigate(
        `/admin/emp_list/emp_edit/${encodeURIComponent(empId)}?${new URLSearchParams({ jobTitle: "", grade: "", division: "" })}`,
      );
    }
  };

  return (
    <>
      <div className="w-full bg-white rounded-2xl overflow-hidden h-full flex flex-col">
        {/* ── Header ──────────────────────────────────────────── */}
        <div className="flex items-center justify-between px-2 pt-5 pb-3 flex-shrink-0">
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-slate-400">
              Alerts
            </p>
            <h2 className="text-base font-bold text-slate-900 leading-tight mt-0.5">
              Expiry Tracker
            </h2>
          </div>
        </div>
        {/* Total expiring badge */}
        <div className="flex justify-left w-30 ml-2">
          {!loading && totalExpiring > 0 && (
            <div className="w-30 flex items-center gap-1.5 rounded-full bg-amber-50 border border-amber-200 px-3 py-1">
              <span className="h-1.5 w-1.5 rounded-full bg-amber-500 animate-pulse" />
              <span className="text-xs font-semibold text-amber-700">
                {totalExpiring} expiring
              </span>
            </div>
          )}
        </div>

        {/* ── Grid ────────────────────────────────────────────── */}
        <div className="flex-1 overflow-y-auto p-4">
          <div className="grid grid-cols-2 gap-2.5">
            {EXPIRY_ITEMS.map(
              ({
                key,
                label,
                popUpId: pid,
                listName,
                Icon,
                iconBg,
                ringColor,
                countKey,
              }) => {
                const count = countMap[countKey] ?? 0;
                const hasAlerts = count > 0;

                return (
                  <button
                    key={key}
                    onClick={() => {
                      openJobCardModal(pid);
                      setListName(listName);
                    }}
                    className={`
                    group relative flex flex-col items-center justify-center gap-2
                    rounded-xl border bg-white p-3
                    transition-all duration-200 cursor-pointer
                    hover:shadow-md hover:-translate-y-0.5 hover:border-slate-300
                    focus:outline-none ${ringColor} focus:ring-2 focus:ring-offset-1
                    ${hasAlerts ? "border-slate-200" : "border-slate-100"}
                  `}
                  >
                    {/* Alert dot */}
                    {hasAlerts && (
                      <span className="absolute top-2 right-2 flex h-4 w-4 items-center justify-center rounded-full bg-amber-100">
                        <span className="text-[9px] font-bold text-amber-600">
                          {count}
                        </span>
                      </span>
                    )}

                    {/* Icon tile */}
                    <div
                      className={`flex h-9 w-9 items-center justify-center rounded-xl ${iconBg} shadow-sm transition-transform duration-200 group-hover:scale-110`}
                    >
                      <Icon className="h-4 w-4 text-white" />
                    </div>

                    {/* Label */}
                    <div className="text-center">
                      <p className="text-[11px] font-semibold text-slate-700 leading-tight">
                        {label}
                      </p>
                      {loading ? (
                        <div className="mx-auto mt-1 h-2.5 w-8 animate-pulse rounded-full bg-slate-100" />
                      ) : (
                        <p
                          className={`mt-0.5 text-xs font-bold ${hasAlerts ? "text-amber-600" : "text-slate-300"}`}
                        >
                          {count}
                        </p>
                      )}
                    </div>
                  </button>
                );
              },
            )}
          </div>
        </div>
      </div>

      <TopCardPopUpExpiryList
        showJobCardPopUp={showJobCardPopUp}
        closeJobCardModal={closeJobCardModal}
        popUpId={popUpId}
        dataFromParent={dataFromParent}
        list_name={list_name}
        onNavigateToEdit={navigateToEdit}
      />
    </>
  );
};

export default ExpiryCount;
